import { SvgIcon, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import { tileTextStyle } from "./style.ts";

const Mobiles: React.FC<{ selected: boolean }> = ({ selected }) => {
	const [hovered, setHovered] = useState(false);
	const theme = useTheme();
	const idleBackground = theme.palette.secondary.main;
	const hoverBackground = theme.palette.secondary.light;
	const selectedBackGround = theme.palette.info.main;

	const backGroundColor = selected ? selectedBackGround : hovered ? hoverBackground : idleBackground;
	return (
		<SvgIcon
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			viewBox="0 0 460 259"
			sx={{ width: "100%", height: "auto" }}
		>
			<defs>
				<style>{".cls-2{stroke-miterlimit:10;fill:none;stroke:#fff}"}</style>
			</defs>
			<g id="Vrstva_2-2" data-name="Vrstva 2">
				<rect
					style={{
						fill: backGroundColor,
					}}
					x="0"
					width="460"
					height="259"
				/>
				<g>
					<path className="cls-2" d="M0,237.18c132.91-.24,273.64-.24,406.21,0" />
					<line className="cls-2" x1="460" y1="237.18" x2="405.06" y2="237.18" />
				</g>
			</g>
			<g id="telefon">
				<g>
					<circle className="cls-2" cx="315.71" cy="218.73" r="5.97" />
					<path
						className="cls-2"
						d="M345.8,228.8h-58.86c-2.61,0-4.72-2.17-4.72-4.85v-122.42c0-2.68,2.11-4.85,3.93-4.83h58.86c3.39-.02,5.51,2.15,5.51,4.83v122.42c0,2.68-2.11,4.85-4.72,4.85Z"
					/>
					<path
						className="cls-2"
						d="M346.98,237h-61.88c-5.88,0-10.64-4.78-10.64-10.67V97.77c0-5.89,4.76-10.67,10.64-10.67h61.88c5.88,0,10.64,4.78,10.64,10.67v128.56c0,5.89-4.76,10.67-10.64,10.67Z"
					/>
				</g>
			</g>
			<text
				id="texty"
        style={tileTextStyle}
				transform="translate(20 44.289)"
			>
				{"Mobilní telefony"}
			</text>
		</SvgIcon>
	);
};

export default Mobiles;
